<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-04-30 20:59:55
 * @LastEditors: ???
 * @LastEditTime: 2022-06-11 14:42:18
-->
<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input @keyup.enter.native="searchQuery" v-model="queryParam.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="社区">
          <el-select
            v-model="queryParam.community"
            clearable
            filterable
            remote
            @change="communityChange"
            :remote-method="remoteMethod"
            :loading="communityLoading"
          >
            <el-option
              v-for="item in communityOpts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="街道">
          <el-select
            v-model="queryParam.street"
            clearable
            filterable
            remote
            :remote-method="streetRemoteMethod"
            @change="streetChange"
            :loading="streetLoading"
          >
            <el-option
              v-for="item in streetOpts"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="回收员"> -->
        <!-- <el-select
            v-model="queryParam.recycleUserId"
            clearable
            filterable
            remote
            :remote-method="recyclerRemoteMethod"
            @change="streetChange"
            :loading="streetLoading"
          >
            <el-option
              v-for="item in streetOpts"
              :key="item.wlAddressDictId"
              :label="item.name"
              :value="item.wlAddressDictId"
            >
            </el-option>
        </el-select>-->
        <!-- </el-form-item> -->

        <el-form-item label="预约时间">
          <el-date-picker
            style="width: 350px"
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <!-- <el-button type="primary" @click="handleExportXls">导出</el-button> -->
          <div class="exportSelectBox">
            <el-select value="更多" size="mini" @change="selectExport">
              <el-option value="/user/statistical/bookingOrder/export" label="导出"></el-option>
              <el-option value="/user/statistical/exportCancelOrder" label="导出取消订单"></el-option>
            </el-select>
          </div>

          <!-- <el-button size="mini" type="primary" disabled @click="handleAdd()"
            >新增</el-button
          >-->
        </el-form-item>
      </el-form>
      <el-tabs v-model="queryParam.status" type="card" @tab-click="searchQuery">
        <el-tab-pane
          :label="`新订单（${summaryData.newOrder.num}）超时（${summaryData.newOrder.timeoutNum}）`"
          name="0"
        ></el-tab-pane>
        <el-tab-pane
          :label="`进行中（${summaryData.doingOrder.num}）超时（${summaryData.doingOrder.timeoutNum}）`"
          name="1"
        ></el-tab-pane>
        <el-tab-pane
          :label="`已完成（${summaryData.completeOrder.num}）超时（${summaryData.completeOrder.timeoutNum}）`"
          name="2"
        ></el-tab-pane>
        <el-tab-pane
          :label="`已取消（${summaryData.cancelOrder.num}）超时（${summaryData.cancelOrder.timeoutNum}）`"
          name="3"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #faceUrl="slotData">
        <el-image
          v-if="getAvatar(slotData.data.row.faceUrl)"
          :src="getAvatar(slotData.data.row.faceUrl)"
          :preview-src-list="[...getAvatar(slotData.data.row.faceUrl)]"
          style="width: 60px; height: 60px"
        >
          <div slot="placeholder" class="image-slot">
            加载中
            <span class="dot">...</span>
          </div>
        </el-image>
        <span v-else>未上传</span>
      </template>

      <template #isOnTime="slotData">
        <span v-show="slotData.data.row.isOnTime == 1">是</span>
        <span v-show="slotData.data.row.isOnTime == 0">否</span>
      </template>
      <template #needRecyclingBag="slotData">
        <span v-show="slotData.data.row.needRecyclingBag == 1">是</span>
        <span v-show="slotData.data.row.needRecyclingBag == 0">否</span>
      </template>

      <template #handlerSlot="slotData">
        <el-button size="mini" @click="showDetail(slotData.data.row)">详情</el-button>
        <el-button size="mini" type="primary" @click="handleRemarkEdit(slotData.data.row)">备注</el-button>
        <el-button
          v-show="queryParam.status == 0 || queryParam.status == 1"
          size="mini"
          type="primary"
          @click="handleEditTime(slotData.data.row)"
        >修改预约时间</el-button>
        <!-- <el-button size="mini" @click="handleEdit(slotData.data.row)"
          >转派</el-button
        >-->
        <!-- <el-button
          type="danger"
          size="mini"
          disabled
          @click="handleDelete(slotData.data.row.id)"
          >删除</el-button
        >-->
      </template>
    </e-table>

    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
    <remarkModal ref="remark" @ok="searchQuery"></remarkModal>
    <orderTimeModal ref="time" @ok="searchQuery"></orderTimeModal>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import modalForm from './component/addModal'
import remarkModal from './component/remarkModal'
import orderTimeModal from './component/orderTimeModal'
import detail from './component/orderDetailModal'
import { getLast7Days } from '@/utils/util'

import eTable from '@/components/table'
import { listMixin } from '@/mixins/listMixin'
import { postAction, getAction } from '@/api/manage'
import {
  getCommunityList,
  getStreetList,
  getOrderingSummary,
} from '@/api/sign'

export default {
  components: { eTable, modalForm, remarkModal, orderTimeModal, detail },
  mixins: [listMixin],
  props: {},
  data () {
    return {
      summaryData: {},
      dateRange: [],
      deleteKey: 'userId',
      url: {
        list: '/user/statistical/bookingOrder',
        delete: 'userManager/deleteById',
        deleteBatch: 'userManager/deleteById',
        exportXlsUrl: 'user/statistical/bookingOrder/export',
      },
      queryParam: {
        status: 0,
      },
      communityOpts: [],
      streetOpts: [],
      communityLoading: false,
      streetLoading: false,
      //字段权限
      columns: [
        { field: 'orderNo', label: '订单编号', width: 160 },
        { field: 'userName', label: '姓名' },

        { field: 'appointmentTimeEnd', label: '预约时间' },
        {
          field: 'isOnTime',
          label: '是否超时',
          slotName: 'isOnTime',
          columnType: 'slot',
        },

        { field: 'streetName', label: '街道' },

        { field: 'detailAddress', label: '预约地址' },

        { field: 'phone', label: '联系方式' },
        { field: 'goodType', label: '预约类型' },

        {
          field: 'orderContext',
          label: '预约内容',
        },
        {
          field: 'rebycleUserName',
          label: '回收员',
        },
        {
          field: 'orderTime',
          label: '下单时间',
        },
        {
          field: 'needRecyclingBag',
          label: '是否需要回收袋',
          slotName: 'needRecyclingBag',
          columnType: 'slot',
        },

        {
          width: 350,
          label: '编辑',
          slotName: 'handlerSlot',
          columnType: 'slot',
        },
      ],
    }
  },
  watch: {},
  computed: {},
  methods: {
    selectExport (e) {
      if (!this.queryParam.beginTime && !this.queryParam.endTime) return this.$message.warning("请选择日期后导出")
      let newName = ''
      if (e === "/user/statistical/bookingOrder/export") newName = '导出'
      if (e === "/user/statistical/exportCancelOrder") newName = '导出取消订单'
      this.handleExportXls(newName, e)
      // this.handleExportXls(
      //   e === "/wlInspectionRecord/exportGssPunishment"
      //     ? "指导员罚款"
      //     : "罚款明细",
      //   e
      // );
    },
    searchReset () {
      this.queryParam = {
        status: '0',
      }
      this.initDictConfig()
      this.loadData(1)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.isOnTime === 1) {
        return 'danger-row'
      }
      return ''
    },
    loadOtherData (params) {
      getOrderingSummary(params).then((res) => {
        this.summaryData = res.data
      })
    },
    showDetail (row) {
      this.$refs.detail.edit(row)
      this.$refs.detail.title = '订单详情-' + row.orderNo
    },
    handleRemarkEdit (row) {
      this.$refs.remark.edit(row)
      this.$refs.remark.title = '备注'
    },
    handleEditTime (row) {
      this.$refs.time.edit(row)
      this.$refs.time.title = '修改预约时间'
    },
    dateRangeChange (val) {
      if (val) {
        this.queryParam.beginTime = val[0]
        this.queryParam.endTime = val[1]
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    remoteMethod (name) {
      if (name !== '') {
        this.communityLoading = true
        getCommunityList({ name }).then((res) => {
          this.communityOpts = res.data
          this.communityLoading = false
        })
      } else {
        this.communityOpts = []
        this.communityLoading = false
      }
    },
    streetRemoteMethod (name) {
      if (name !== '') {
        this.streetLoading = true
        getStreetList({ name }).then((res) => {
          this.streetOpts = res.data
          this.streetLoading = false
        })
      } else {
        this.streetOpts = []
        this.streetLoading = false
      }
    },
    recyclerRemoteMethod (name) {
      if (name !== '') {
        this.streetLoading = true
        getStreetList({ name }).then((res) => {
          this.streetOpts = res.data
          this.streetLoading = false
        })
      } else {
        this.streetOpts = []
        this.streetLoading = false
      }
    },

    communityChange (val) {
      getStreetList({}).then(() => { })
    },
    streetChange (val) {
      console.log(val)
    },
    initDictConfig () {
      this.dateRange = getLast7Days()
      this.dateRangeChange(this.dateRange)
    },
    fetchData () {
      console.log(this.ipagination.page)
    },
    add (val) {
      console.log(val)
    },
    edit (val) { },
    del (val) { },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
}
.exportSelectBox {
  display: inline-block;
  margin-left: 10px;
  /deep/.el-input input {
    background: #409eff;
    color: white;
    width: 70px;
    height: 28px;
  }
}
</style>
